var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInProgressIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 52,
    viewBox: "0 0 57 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_12967_183018)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10.5,
    y: 5.89648,
    width: 36,
    height: 36,
    rx: 18,
    fill: "#F5C172"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12967_183018)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.1 13.0215H36.6C36.9 13.0215 37.2 12.8715 37.2 12.4965C37.2 12.1215 36.9 11.8965 36.6 11.8965H20.1C19.725 11.8965 19.5 12.1965 19.5 12.4965C19.5 12.7965 19.725 13.0215 20.1 13.0215Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.825 17.2965C22.344 20.2809 24.0416 22.4234 26.8207 23.7242C23.9485 25.0202 22.275 27.1777 21.75 30.1965V30.4965C21.75 31.0215 21.975 31.5465 22.425 31.9215C22.8 32.2965 23.325 32.5215 23.85 32.5215H33.15C34.275 32.3715 35.025 31.3215 34.875 30.1965C34.3463 27.1564 32.5946 24.9898 29.7226 23.6968C32.5989 22.4011 34.2746 20.2426 34.8 17.2215C34.875 16.6965 34.725 16.1715 34.425 15.7215C34.125 15.2715 33.6 14.9715 33.075 14.8965H23.85C23.25 14.8965 22.8 15.1215 22.35 15.4965C21.975 15.8715 21.75 16.3965 21.75 16.9215C21.75 17.0715 21.75 17.1465 21.825 17.2965ZM28.275 23.0715C25.2 22.0215 23.4 20.0715 22.875 17.0715V16.9215C22.875 16.6965 23.025 16.4715 23.175 16.3215C23.325 16.0965 23.625 16.0215 23.85 16.0215H32.925C33.15 16.0965 33.375 16.1715 33.525 16.3965C33.675 16.6215 33.675 16.8465 33.675 17.0715C33.15 20.0715 31.425 22.0215 28.275 23.0715ZM23.85 31.3965H32.925C33.45 31.3215 33.825 30.8715 33.675 30.3465C33.15 27.3465 31.425 25.3965 28.275 24.3465C25.125 25.3965 23.4 27.3465 22.875 30.3465V30.4965C22.875 30.7215 22.95 30.9465 23.175 31.1715C23.325 31.3215 23.55 31.3965 23.85 31.3965Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1 35.5215H36.6C36.9 35.5215 37.2 35.3715 37.2 34.9965C37.2 34.6215 36.9 34.3965 36.6 34.3965H20.1C19.725 34.3965 19.5 34.5465 19.5 34.9215C19.5 35.2965 19.8 35.5215 20.1 35.5215Z",
    fill: "#333333"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_12967_183018",
    x: 0.0384607,
    y: 0.665715,
    width: 56.9231,
    height: 56.9231,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5.23077
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5.23077
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_12967_183018"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_12967_183018",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12967_183018"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(16.5 11.8965)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInProgressIcon);
export default __webpack_public_path__ + "static/media/InProgressIcon.b3756f7630189978470db8ec190c39d1.svg";
export { ForwardRef as ReactComponent };